import React from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'

const InputSelectComponent =
  ({ style, input_style, label, name, placeholder, value, options, onSelect = false, hidden, required, disabled, display, is_multi }) => {
    if (hidden) return null; // If hidden is true, skip rendering the input
    return (
      <>
        {display
          ?
          <div className={`${style}`} >
            {label !== "" &&
              <label htmlFor={name} className="form-label" >
                {required && <span className="text-danger"> * </span>}{label}
              </label>
            }
            <Select
              name={name}
              value={value} // Match selected values
              options={options}
              onChange={onSelect} // Returns array of values
              isMulti={is_multi} // Enables multi-select
              placeholder={placeholder}
              isDisabled={disabled}
              required={required}
              className={`${input_style}`}
              classNamePrefix="select"
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 999999 }), // z-index fix
                menuList: (base) => ({
                  ...base,
                  maxHeight: '150px',
                  overflowY: 'auto',
                }),
              }}
            />
          </div>
          :
          <div className={`${style}`} >
            <div className="flex">
              {label !== "" &&
                <div className={`col-md-3`} >
                  <label
                    className="form-label"
                    htmlFor={name}
                  >
                    {required && <span className="text-danger"> * </span>}{label}
                  </label>
                </div>
              }
              <div className={`col-md-9`} >
                <Select
                  name={name}
                  value={value} // Match selected values
                  options={options}
                  onChange={onSelect} // Returns array of values
                  isMulti={is_multi} // Enables multi-select
                  placeholder={placeholder}
                  isDisabled={disabled}
                  required={required}
                  className={`${input_style}`}
                  //className="basic-multi-select"
                  classNamePrefix="select"
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 999999 }), // z-index fix
                    menuList: (base) => ({
                      ...base,
                      maxHeight: '150px',
                      overflowY: 'auto',
                    }),
                  }}
                />
              </div>
            </div>
          </div>
        }
      </>
    )
  }
InputSelectComponent.propTypes = {
  style: PropTypes.string,
  input_style: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.any,
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onSelect: PropTypes.func.isRequired,
  is_multi: PropTypes.bool,
  hidden: PropTypes.bool,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  display: PropTypes.bool,
}

export default InputSelectComponent
